import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

export const CompletedIcon = ({ completed }: { completed: boolean }) => {
  return (
    <CheckCircleOutlinedIcon
      sx={{ color: `${completed ? '#0AC265' : '#978FA3'}` }}
      fontSize="small"
    />
  );
};
